import { ofType } from "redux-observable";
import { of, from } from "rxjs";
import { mergeMap, catchError, switchMap } from "rxjs/operators";
import { DELETE_NOTE_BEGIN, deleteNoteSuccess, fetchNotes, logError } from "../actions";
import SocialAPIUtils from "../utils/SocialAPIUtils";
export default function deleteNote(action$, state$) {
    return action$.pipe(ofType(DELETE_NOTE_BEGIN), mergeMap(function(action) {
        return from(SocialAPIUtils.deleteNote(action.note, action.nodeIds).then(function(response) {
            return action;
        }).catch(function(err) {
            console.error(err);
            logError({
                err: err,
                key: "delete_note"
            });
        })).pipe(switchMap(function(_action) {
            return [
                deleteNoteSuccess({
                    note: _action.note
                }),
                fetchNotes({
                    group: state$.value.groups.noteGroup,
                    options: {
                        nodes: _action.nodeIds
                    }
                })
            ];
        }), catchError(function(error) {
            return of(logError({
                error: error,
                key: "delete_note"
            }));
        }));
    }), catchError(function(error) {
        return of(logError({
            error: error,
            key: "delete_note"
        }));
    }));
}
